<template>
  <div>
    <p>メッセージ内容</p>
    <p style="font-size: 13px; padding: 10px">
      <b-field>
        <textarea
          class="textarea disp-scroll"
          placeholder="例：以下のボタンからダウンロードしてください。"
          :value="scenarioEdit.mainmessage"
          @input="updateMainmessage($event.target.value)"
          :disabled="scenarioEdit.is_confirm"
        ></textarea>
      </b-field>
    </p>
    <div class="dot-line"></div>
    <div v-if="downloadParameter.filename.length > 0">
      <p>現在設定されているファイル名</p>
      <p v-for="(name, index) in downloadParameter.filename" :key="index">{{ name }}</p>
    </div>
    <div v-else>
      <p>現在設定されているファイルはありません</p>
    </div>
    <div class="dot-line"></div>
    <p>ダウンロード用ファイルを指定</p>
    <div v-for="(item, i) in downloadParameter.filepaths" :key="i">
      <b-input
        style="width: 95%"
        placeholder="アップロードファイル"
        :value="item[0]"
        @input="updateFilepath(i, $event)"
        max-length="100"
        disabled="true"
      ></b-input>
    </div>
    <b-upload
      v-model="uploadedFile"
      :disabled="downloadParameter.filepaths.length >= 6 || scenarioEdit.is_confirm"
    >
      <a
        class="button is-fullwidth is-primary"
        :disabled="downloadParameter.filepaths.length >= 6 || scenarioEdit.is_confirm"
      >
        <b-icon icon="upload"></b-icon>
        <span>ファイルをアップロードする</span>
      </a>
    </b-upload>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
      required: true,
    },
    downloadParameter: {
      type: Object,
      required: true,
    },
    isRoboPartsSetView: {
      type: Boolean,
      required: true,
    },
    loadFile: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      uploadedFile: {}
    }
  },
  watch: {
    uploadedFile() {
      this.loadFile(this.uploadedFile)
    }
  },
  methods: {
    updateMainmessage(value) {
      this.$emit('update-main-message', value)
    },
    updateFilepath(i, value) {
      this.$emit('update-file-path', i, value)
    },
  },
}
</script>

<style scoped lang="scss">
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditDownload.vue